window.enableHoverVideoForCard = function(card) {
  const video = card.querySelector(".product-card__video");

  if (video) {
    card.addEventListener("mouseenter", function() {
      if (video.dataset.poster && !video.getAttribute('poster')) video.setAttribute('poster', video.dataset.poster);
      video.play();
    });

    card.addEventListener("mouseleave", function() {
      video.pause();
      video.currentTime = 0;
    });
  }
};


function initializeSidebarMenu() {
  document.querySelectorAll('.header-sidebar__linklist-button').forEach(button => {
    button.addEventListener('click', function() {
      const panelId = button.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);

      if (panel) {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        panel.hidden = isExpanded;
        panel.classList.toggle('is-open', !isExpanded);
      }
    });
  });
}

function initializeBackButton() {
  document.querySelectorAll('.header-sidebar__back-button-child').forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();

      const parentPanel = button.closest('.header-sidebar__sub-panel-child');
      
      if (parentPanel) {
        parentPanel.setAttribute('hidden', 'true');
        parentPanel.classList.remove('is-open');

        const parentPanelId = parentPanel.id;
        const linkButton = document.querySelector(`.header-sidebar__linklist-button[aria-controls="${parentPanelId}"]`);
        
        if (linkButton) {
          linkButton.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });
}

function checkMenuWrap() {
  const nav = document.querySelector('nav.header__primary-nav');
  if (!nav) return;

  const items = nav.querySelectorAll('.header__primary-nav-item');
  const  secondaryItems = document.querySelector('nav.header__secondary-nav');
  const header = nav.closest('.header');

  if (secondaryItems) {
    secondaryItems.style.opacity = '1';
  }

  if(nav){
    nav.style.opacity = '1';
  }
  
  if (!header || items.length === 0) return;

  const firstTop = items[0].offsetTop;
  let hasWrap = false;

  for (let i = 1; i < items.length; i++) {
    if (items[i].offsetTop > firstTop) {
      hasWrap = true;
      break;
    }
  }

  if (hasWrap && !header.classList.contains('has-wrap')) {
    header.classList.add('has-wrap');
  } else if (!hasWrap && header.classList.contains('has-wrap')) {
    header.classList.remove('has-wrap');
  }
}

window.addEventListener('resize', checkMenuWrap);

document.addEventListener("DOMContentLoaded", function() {
  checkMenuWrap();
  initializeSidebarMenu();
  initializeBackButton();
});

function setInstafeedImageAltText(root = document) {
  const feed = root.querySelector?.('#insta-feed') || document.querySelector('#insta-feed');
  if (!feed) return;

  feed.querySelectorAll('img').forEach((image) => {
    if (image.getAttribute('alt')?.trim()) return;

    const linkedPost = image.closest('a');
    const fallbackAlt = linkedPost?.getAttribute('aria-label') ||
      linkedPost?.getAttribute('title') ||
      image.getAttribute('title') ||
      'Instagram post by JOELLE Collection';

    image.setAttribute('alt', fallbackAlt);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const feed = document.querySelector('#insta-feed');
  if (!feed) return;

  setInstafeedImageAltText();

  const observer = new MutationObserver(() => {
    setInstafeedImageAltText();
  });

  observer.observe(feed, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['alt', 'src']
  });
});

document.addEventListener('DOMContentLoaded', function() {
  var productSwipers = document.querySelectorAll('.product-swiper');
  // SG perf: Swiper CSS/JS are no longer loaded on every page; fetch them only when a product-card slideshow is present.
  if (productSwipers.length && window.loadThemeSwiper) {
    window.loadThemeSwiper(function() {
  productSwipers.forEach(function(swiperEl) {
    var pid = swiperEl.id.replace('product-swiper-', '');
    var prevBtnSelector = '.swiper-button-prev-' + pid;
    var nextBtnSelector = '.swiper-button-next-' + pid;
    var paginationSelector = '.swiper-pagination-' + pid;

    var swiper = new Swiper('#' + swiperEl.id, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: nextBtnSelector,
        prevEl: prevBtnSelector,
      },
      pagination: {
        el: paginationSelector,
        clickable: true,
      },
      preloadImages: false,
      lazy: true,
    });
  });
    });
  }

  document.querySelectorAll('collection-layout-switch').forEach(switchEl => {
    const activeBtn = switchEl.querySelector('button[type="button"].is-active');
    if (activeBtn) {
      const value = activeBtn.value;
      document.querySelectorAll('.product-swiper.only-mobile').forEach(swiperEl => {
        const swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
        if (!swiperWrapper) return;
        const slides = Array.from(swiperWrapper.children);
        let targetSlide = null;
        slides.forEach(slide => {
          const img = slide.querySelector('img[data-view]');
          if (img && img.getAttribute('data-view') === value) {
            targetSlide = slide;
          }
        });
        if (!targetSlide) return;
        if (slides[0] !== targetSlide) {
          swiperWrapper.insertBefore(targetSlide, slides[0]);
        }
      });
    }
  });

  document.querySelectorAll('collection-layout-switch').forEach(switchEl => {
    switchEl.querySelectorAll('button[type="button"]').forEach(btn => {
      btn.addEventListener('click', () => {
        const value = btn.value;
        document.querySelectorAll('.product-swiper.only-mobile').forEach(swiperEl => {
          const swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
          if (!swiperWrapper) return;
          const slides = Array.from(swiperWrapper.children);
          let targetSlide = null;
          slides.forEach(slide => {
            const img = slide.querySelector('img[data-view]');
            if (img && img.getAttribute('data-view') === value) {
              targetSlide = slide;
            }
          });
          if (!targetSlide) return;
          if (slides[0] !== targetSlide) {
            swiperWrapper.insertBefore(targetSlide, slides[0]);
          }
        });
      });
    });
  });
});


(function patchVariantPicker() {
  const LOADING_STYLE = `
    pointer-events: none !important;
    opacity: 0.5 !important;
    cursor: not-allowed !important;
  `;

  const dopatch = () => {
    const VP = customElements.get('variant-picker');
    if (!VP || VP.prototype.__lockPatchApplied) return;
    VP.prototype.__lockPatchApplied = true;

    const originalConnectedCallback = VP.prototype.connectedCallback;

    VP.prototype.connectedCallback = async function() {
      await originalConnectedCallback.call(this);

      const formId = this.getAttribute('form-id');
      const form = document.forms[formId];
      if (!form) return;

      const checkedOptions = Array.from(form.elements)
        .filter(el => el.matches('input[data-option-position]:checked'))
        .sort((a, b) => +a.getAttribute('data-option-position') - +b.getAttribute('data-option-position'))
        .map(el => el.value);

      const initialVariant = this.selectedVariant;
      const initialOptions = initialVariant?.options || [];

      const isDifferent = checkedOptions.length > 0 &&
        checkedOptions.some((val, i) => val !== initialOptions[i]);

      if (isDifferent) {
        this.selectCombination({ optionValues: checkedOptions, productChange: false });
      }
    };

    const original = VP.prototype.selectCombination;

    VP.prototype.selectCombination = async function(args) {
      const formId = this.getAttribute('form-id');

      const inputs = document.querySelectorAll(
        `input[data-option-position][form="${formId}"], label[for]`
      );

      const addToCartBtns = document.querySelectorAll(
        `button[type="submit"][form="${formId}"],
         form#${formId} button[type="submit"],
         .shopify-payment-button__button`
      );

      inputs.forEach(el => el.setAttribute('style', LOADING_STYLE));
      addToCartBtns.forEach(el => {
        el.setAttribute('disabled', 'disabled');
        el.setAttribute('style', LOADING_STYLE);
      });
      this.setAttribute('style', LOADING_STYLE);

      try {
        await original.call(this, args);
      } finally {
        inputs.forEach(el => el.removeAttribute('style'));
        addToCartBtns.forEach(el => {
          el.removeAttribute('disabled');
          el.removeAttribute('style');
        });
        this.removeAttribute('style');
      }
    };
  };

  if (customElements.get('variant-picker')) {
    dopatch();
  } else {
    customElements.whenDefined('variant-picker').then(dopatch);
  }
})();

// SG perf: product-card hover videos are rendered with preload="none" and a deferred poster (data-poster) so phones (no hover) never download them.
// On desktop (hover-capable pointer), once the page has loaded, poster + preload="metadata" are restored for the videos that come near the viewport.
(function() {
  function upgradeVideo(video) {
    if (video.dataset.poster && !video.getAttribute('poster')) video.setAttribute('poster', video.dataset.poster);
    video.preload = 'metadata';
  }
  function upgradeCardVideos() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var videos = document.querySelectorAll('video.product-card__video[preload="none"]');
    if (!('IntersectionObserver' in window)) { videos.forEach(upgradeVideo); return; }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { upgradeVideo(entry.target); observer.unobserve(entry.target); }
      });
    }, { rootMargin: '200px 0px' });
    videos.forEach(function(video) { observer.observe(video); });
  }
  function schedule() {
    if ('requestIdleCallback' in window) { requestIdleCallback(upgradeCardVideos, { timeout: 4000 }); }
    else { setTimeout(upgradeCardVideos, 2000); }
  }
  if (document.readyState === 'complete') { schedule(); } else { window.addEventListener('load', schedule); }
})();
